import { Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";

import LoadingState from "shared/components/state/LoadingState";
import { getAdminUrl, isAdminHost } from "shared/utils/host-routing";
import { useAuthStore } from "app/store/auth.store";

const RedirectToAdminHost = () => {
    const location = useLocation();
    const destination = getAdminUrl(`${location.pathname}${location.search}${location.hash}`);

    useEffect(() => {
        window.location.replace(destination);
    }, [destination]);

    return <LoadingState message="Opening the admin portal..." />;
};

export const AdminHostRoute = ({ children, requiresAuth = false }) => {
    const location = useLocation();
    const { isAuthenticated } = useAuthStore();

    if (!isAdminHost()) {
        return <RedirectToAdminHost />;
    }

    if (requiresAuth && !isAuthenticated) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    return children;
};

export const PublicHostRoute = ({ children }) => {
    const { isAuthenticated } = useAuthStore();

    if (isAdminHost()) {
        return <Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />;
    }

    return children;
};
